import { LiveChatSDKContextType } from '@inno-sdk/livechat-sdk'
import { getIsInsideWindow } from 'shared/utils/getIsInsideWindow'

import { BRIDGE_KEY } from './LiveChatSDKBridge.constants'

/**
 * Reads the LiveChat SDK context exposed by the parent window via the bridge key.
 * Used by iframe children to inherit the parent window's LiveChat SDK instance
 * instead of creating their own.
 *
 * @returns The parent window's LiveChat SDK context, or `undefined` if not inside
 * an iframe or if the parent has not yet exposed its context.
 */
export const getParentContext = (): LiveChatSDKContextType | undefined => {
  if (typeof window === 'undefined' || !getIsInsideWindow()) return undefined

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window.parent as any)?.[BRIDGE_KEY] || undefined
}

/**
 * Reads the LiveChat SDK context exposed on the current window via the bridge key.
 * Use this to access the LiveChat instance imperatively (outside of React's provider
 * tree) — for example, during logout cleanup where calling `useLiveChatSDK()` would
 * throw if the component is not wrapped in `LiveChatSDKProvider`.
 *
 * @returns The current window's LiveChat SDK context, or `undefined` if the
 * `BridgedLiveChatSDKProvider` has not yet mounted and exposed its context.
 */
export const getLivechatContext = (): LiveChatSDKContextType | undefined => {
  if (typeof window === 'undefined') return undefined

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any)[BRIDGE_KEY] || undefined
}
